import * as React from "react";

function Add(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 15 14" fill="none" {...props}>
      <path d="M6.5 6V0h2v6h6v2h-6v6h-2V8h-6V6h6z" fill="currentColor" />
    </svg>
  );
}

const MemoAdd = React.memo(Add);
export default MemoAdd;
